/**
 * Login Callback Component
 * 
 * Handles the redirect from Okta after successful authentication.
 * Displays loading state while processing the callback.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import './LoginCallback.css';

const LoginCallback = () => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Handle the redirect and parse tokens from URL
        await oktaAuth.handleLoginRedirect();
        
        // Get the original URI or default to home
        const originalUri = oktaAuth.getOriginalUri();
        if (originalUri) {
          navigate(originalUri, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Error handling login callback:', err);
        // Redirect to login on error
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [oktaAuth, navigate]);

  return (
    <div className="callback-container">
      <div className="callback-content">
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
        <h2>Signing you in...</h2>
        <p>Please wait while we complete your authentication</p>
      </div>
    </div>
  );
};

export default LoginCallback;
